/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_difference_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can percentage difference be negative?`)
};

const es_pct_difference_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puede la diferencia porcentual ser negativa?`)
};

const de_pct_difference_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann der prozentuale Unterschied negativ sein?`)
};

const nl_pct_difference_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan percentageverschil negatief zijn?`)
};

const fr_pct_difference_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La différence en pourcentage peut-elle être négative ?`)
};

const it_pct_difference_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La differenza percentuale può essere negativa?`)
};

const pt_br2_pct_difference_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A diferença percentual pode ser negativa?`)
};

const pt_pct_difference_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A diferença percentual pode ser negativa?`)
};

const ja_pct_difference_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセントの差はマイナスになりますか？`)
};

const zh_pct_difference_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比差异可以是负数吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_difference_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_difference_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_difference_faq3_q", locale)
	if (locale === "en") return en_pct_difference_faq3_q(inputs)
	if (locale === "es") return es_pct_difference_faq3_q(inputs)
	if (locale === "de") return de_pct_difference_faq3_q(inputs)
	if (locale === "nl") return nl_pct_difference_faq3_q(inputs)
	if (locale === "fr") return fr_pct_difference_faq3_q(inputs)
	if (locale === "it") return it_pct_difference_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_difference_faq3_q(inputs)
	if (locale === "pt") return pt_pct_difference_faq3_q(inputs)
	if (locale === "ja") return ja_pct_difference_faq3_q(inputs)
	return zh_pct_difference_faq3_q(inputs)
};